{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "Það eru engar {integrationId} samþættingar stilltar á þessum reikningi.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Virkt",
      "DISABLED": "Slökkt"
    },
    "CONFIGURE": "Configure",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Are you sure to delete?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Yes, Delete",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Innhólf",
      "EDIT": {
        "BUTTON_TEXT": "Breyta"
      },
      "DELETE": {
        "BUTTON_TEXT": "Eyða"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Create",
        "CANCEL": "Hætta við"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      }
    },
    "EDIT": {
      "TITLE": "Breyta {name}",
      "FORM": {
        "SUBMIT": "Uppfæra",
        "CANCEL": "Hætta við"
      },
      "API": {
        "SUCCESS_MESSAGE": "Samþætting uppfærð",
        "ERROR_MESSAGE": "Náði ekki að tengjast spjallþjóni, vinsamlegast reyndu aftur síðar"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connect"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Samstilltu tölvupóst og vefspjall við Daktela reikninginn þinn.",
      "RETINO": "Retino kemur skipulagi á stjórnun skila og kvartana.",
      "MAILSHIP": "Mailship er vörugeymslu- og pöntunarafgreiðslukerfi. Skoðaðu stöðu pöntunar, rakningu og sendingarupplýsingar.",
      "RAYNET": "Tengdu Raynet CRM reikninginn þinn til að fá aðgang að viðskiptavinagögnunum þínum. Bættu við tengingu með Raynet notandanafni og API token."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Prófa tengingu",
      "SUCCESS": "Tenging tókst",
      "ERROR": "Tenging mistókst. Vinsamlegast athugaðu auðkennin þín."
    }
  }
}
